import { tv } from 'tailwind-variants'

export const selectionButton = tv({
  slots: {
    container:
      'flex w-full cursor-pointer flex-row items-center justify-between gap-x-4 rounded-lg border border-ui-grey-500 px-4 py-[12px] hover:opacity-70 active:opacity-70',
    textContainer: 'flex flex-1 flex-col items-start justify-center gap-y-1',
    aidContainer: 'h-6 w-6 p-0.5',
    aid: 'flex h-5 w-5 flex-row items-center justify-center border border-ui-grey-500',
    radioDot: 'h-3 w-3 rounded-full bg-brand-dark',
  },
  variants: {
    type: {
      radio: {
        aid: 'rounded-full',
      },
      checkbox: {
        aid: 'rounded',
      },
      noaid: {
        aid: 'hidden',
      },
    },
    disabled: {
      true: {
        container: 'cursor-default opacity-40',
      },
    },
    selected: {
      true: {
        container: 'border-2 border-brand-dark',
        aid: 'border-brand-dark',
      },
    },
    hasError: {
      true: {},
    },
    noOutline: {
      true: {
        container: 'border-0 aria-selected:p-4',
      },
    },
  },
  compoundVariants: [
    {
      hasError: true,
      className: {
        container: 'border-ui-red',
        aid: 'border-ui-red',
      },
    },
    {
      selected: true,
      type: 'checkbox',
      className: {
        aid: 'bg-brand-dark',
      },
    },
    {
      selected: true,
      type: 'radio',
      className: {
        aid: 'border border-brand-dark',
      },
    },
  ],
})
